import { Pipe, PipeTransform } from '@angular/core';
import { BrandingService } from '../../core/services/branding.service';

@Pipe({
    name: 'displayBrandingAttr',
    standalone: false
})
export class DisplayBrandingAttrPipe implements PipeTransform {

  constructor(private brandingService: BrandingService) {
  }

  transform(value: string, property: string = null, defaultValue: string = null): string {
    const branding = this.brandingService.getBrandingInfoSnapshot();

    if (property) {
      return branding[property]?.find(item => item.name === value)?.value ?? defaultValue;
    }

    return branding[value] ?? defaultValue;
  }

}
